import { BasePage } from '@/components/ui/base-page'
import { ContactForm } from '@/components/forms/ContactForm'
import { Mail, MapPin, Phone } from 'lucide-react'

export function ContactPage() {
    return (
        <BasePage
            title="Contact Us"
            description="Get in touch with our team"
        >
            <div className="container py-12">
                <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
                    {/* Contact Information */}
                    <div>
                        <h1 className="text-3xl font-bold mb-6">Get in Touch</h1>
                        <p className="text-muted-foreground mb-8">
                            Have questions about our services? Looking to collaborate?
                            Reach out to us and our team will get back to you shortly.
                        </p>

                        <div className="space-y-6">
                            <div className="flex items-start">
                                <div className="bg-primary/10 rounded-full p-3 mr-4">
                                    <Mail className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <h3 className="font-medium mb-1">Email</h3>
                                    <p className="text-muted-foreground">team+contact@pshg.co</p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="bg-primary/10 rounded-full p-3 mr-4">
                                    <Phone className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <h3 className="font-medium mb-1">Phone</h3>
                                    <p className="text-muted-foreground">+1 (888) 123-4567</p>
                                </div>
                                </div>

                            <div className="flex items-start">
                                <div className="bg-primary/10 rounded-full p-3 mr-4">
                                    <MapPin className="w-5 h-5 text-primary" />
                                </div>
                                    <div>
                                    <h3 className="font-medium mb-1">Location</h3>
                                    <p className="text-muted-foreground">San Francisco, CA</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="bg-muted p-6 rounded-lg">
                        <h2 className="text-xl font-semibold mb-6">Send us a Message</h2>
                        <ContactForm />
                    </div>
                </div>
            </div>
        </BasePage>
    )
} 